import React, { useState, useEffect } from 'react';

const Timer = ({ seconds, setSeconds }) => {
  let interval;

  useEffect(() => {
    interval = setInterval(() => {
      setSeconds(prevSeconds => { if (prevSeconds >= 1) { return prevSeconds - 1 } else { return 0 } });
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <span className='mx-1'>
      {seconds}
    </span>
  );
};

export default Timer;
